import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HikoValueCards from "./components/HikoValueCards";
import HowHikoWorks from "./components/HowHikoWorks";
import TIKAFramework from "./components/TIKAFramework";
import HikoPhase1 from "./components/HikoPhase1";
import AudienceStrips from "./components/AudienceStrips";
import Wai3564Teaser from "./components/Wai3564Teaser";
import MiniFAQ from "./components/MiniFAQ";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import OurValues from "./components/OurValues";
import AboutUs from "./components/AboutUs";
import Wai3564 from "./components/Wai3564";
import TestimonialsPage from "./components/TestimonialsPage";
import WhyWeCreatedHiko from "./components/WhyWeCreatedHiko";
import WhyCalledHiko from "./components/WhyCalledHiko";
import HikoAbout from "./components/HikoAbout";
import HikoPage from "./components/HikoPage";
import TikaPage from "./components/TikaPage";
import HowItWorksPage from "./components/HowItWorksPage";
import EconomicPrize from "./components/EconomicPrize";
import ProblemSolution from "./components/ProblemSolution";
import ComingSoon from "./components/ComingSoon";

/**
 * ──────────────────────────────────────────────────────────────────────────
 *  MAINTENANCE / LAUNCH GATE
 *  Set to `true`  → every route serves the temporary "Coming Soon" page.
 *  Set to `false` → full draft site is restored unchanged.
 * ──────────────────────────────────────────────────────────────────────────
 */
const MAINTENANCE_MODE = true;

const IndigenousFinancialRail = React.lazy(() => import("./components/IndigenousFinancialRail"));

function App() {
  if (MAINTENANCE_MODE) {
    return (
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<ComingSoon />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <div className="bg-black text-white min-h-screen">
              <Header />
              <Hero />
              <ProblemSolution />
              <HowHikoWorks />
              <TIKAFramework />
              <AudienceStrips />
              <HikoPhase1 />
              <MiniFAQ />
              <CTA />
              <Wai3564Teaser />
              <Footer />
            </div>
          } />
          <Route path="/our-values" element={<OurValues />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/hiko" element={<HikoPage />} />
          <Route path="/tika" element={<TikaPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/wai-3564" element={<Wai3564 />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
